import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import cns from '../../node_modules/classnames/index.js';
import Validation, { getValidation } from '../Validation/index.js';
import { getProp, setProp } from '../Utils/formHelpers.js';
import { getTitle, getRandomId, Presentation } from '../Utils/baseComponentHelper.js';
import useActivation from '../Hooks/useActivation.js';
import useValidations from '../Hooks/useValidations.js';
import ValidationViewer from '../Validation/ValidationViewer.js';

/**
Le textarea sono input che generano automaticamente altre linee di testo, per permettere all’utente di inserire più testo.
 */
class Textarea extends React__default.Component {
    constructor(props) {
        super(props);
        this.getTitle = () => {
            const { title, validations } = this.props;
            return getTitle(title, validations);
        };
        this.isValid = () => getValidation(this.valida()).valid;
        this.reset = () => {
            this.setState({ dirty: false });
        };
        this.valida = () => {
            const { name, validations, value, stato, } = this.props;
            if (!validations) {
                return { valid: true };
            }
            return Validation.validateAll(validations, (stato && name && getProp(name, stato)) || value || '');
        };
        this.notifica = (event) => {
            const { name, onChange, onFormChange, stato, } = this.props;
            const { value } = event.target;
            if (onFormChange) {
                const obj = {};
                setProp(name, value, obj, stato);
                onFormChange(obj, name, value);
            }
            onChange === null || onChange === void 0 ? void 0 : onChange(event);
        };
        this.onFocus = () => {
            this.setState({ focused: true });
        };
        this.onBlur = (event) => {
            const { onBlur } = this.props;
            this.setState({ focused: false, dirty: true });
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
        };
        this.state = {
            dirty: false,
            focused: false,
        };
        this.uniqueid = getRandomId();
    }
    componentDidMount() {
        const { name, addToForm } = this.props;
        if (addToForm && name) {
            addToForm(name, this.valida(), this.reset);
        }
    }
    componentWillUnmount() {
        const { name, removeFromForm } = this.props;
        if (removeFromForm && name) {
            removeFromForm(name);
        }
    }
    render() {
        const _a = this.props, { className, disabled: disabledP, readOnly: readOnlyP, name, title, value, validations, addToForm, isValid, onFormChange, removeFromForm, resetta, placeholder, stato, validare } = _a, others = __rest(_a, ["className", "disabled", "readOnly", "name", "title", "value", "validations", "addToForm", "isValid", "onFormChange", "removeFromForm", "resetta", "placeholder", "stato", "validare"]);
        const { disabled, readOnly } = useActivation(disabledP, readOnlyP); // NOSONAR
        const { dirty, focused } = this.state;
        const validazione = getValidation(this.valida());
        if (isValid != null && name) {
            isValid(name, validazione.valid, validazione.messages || []);
        }
        const contesto = (stato && name && getProp(name, stato));
        const { hasError, hasWarning } = useValidations(validare, dirty, validazione); // NOSONAR
        const classes = cns('textarea', (contesto == undefined || contesto === '') ? 'textarea--empty' : '', hasError ? 'textarea--invalid' : 'textarea--valid', {
            'textarea--focus': focused,
            'textarea--readOnly': readOnly,
        }, className);
        const titleClasses = cns('textarea__title', {
            'textarea__title--readOnly': readOnly,
        });
        const label = name || title;
        return (jsxs("div", { className: classes, children: [jsxs("div", { className: "textarea__expander validationViewer__target", children: [jsxs("pre", { className: "textarea__backing", children: [contesto || value || '', ' ', jsx("br", {})] }), jsx("textarea", Object.assign({ id: this.uniqueid, autoComplete: `textarea-${this.uniqueid}` }, others, { className: "textarea__input", disabled: disabled, readOnly: readOnly, onBlur: this.onBlur, onChange: this.notifica, onFocus: this.onFocus, ref: (r) => { this.refTextArea = r; }, value: new Presentation({ readOnly }).format(contesto || value || ''), placeholder: placeholder })), label && jsx("label", { htmlFor: this.uniqueid, className: "input__label", children: label }), title && jsx("span", { className: titleClasses, children: this.getTitle() }), jsx("span", { className: "textarea__bar" })] }), jsx(ValidationViewer, { hasError: hasError, hasWarning: hasWarning, validazione: validazione })] }));
    }
}
Textarea.defaultProps = {
    className: null,
    disabled: false,
    readOnly: false,
    name: null,
    onBlur: null,
    onChange: null,
    title: null,
    validations: null,
    value: null,
    placeholder: undefined,
};

export { Textarea as default };
